<template>
    <div :class="'async-'+component +' async-component'">
      <component ref="asyncComponent" :is="remote" v-if="remote" :test="test" @handler="haha" />
    </div>
  </template>

  <script>
  import Vue from 'vue'
  import $ from 'jquery'
  import {
    loadModule
  } from 'vue3-sfc-loader/dist/vue2-sfc-loader.js'

  export default {
    name: 'RemoteComponent',
    inheritAttrs: false,
    props: {
        // 远程vue文件名称
        component: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        remote: null,
        test: "123"
      }
    },
    mounted() {
      this.load()
    },
    methods: {
      haha(data) {
        // alert(data)
      },
      child() {
        this.$refs.asyncComponent.handler("")
      },
      // 加载
      async load() {
        let url = "";

        // if (window.location.href.includes("www.kia.cn")) {
        //   url = "https://" + "www.kia.cn/" + `${this.component}.vue`
        // }else{
        //   url = "https://" + "uat.kia.cn/" + `/${this.component}.vue`
        // }
        if (window.location.href.includes("uat.kia.cn")) {
          url = "https://" + "uat.kia.cn/" + `/${this.component}.vue`
        }else{
          url = "https://" + "www.kia.cn/" + `${this.component}.vue`
        }

        const com = await loadModule(url, {
          moduleCache: {
            vue: Vue,
            // jquery:require('jquery'),
            jquery:$,
          },
          // 获取文件
          async getFile(url) {
            const url2 = url.replace('.vue', '.html');

            const res = await fetch(url2)
            if (!res.ok) {
              throw Object.assign(new Error(`${res.statusText} ${url2}`), {
                res
              })
            }
            return {
              getContentData: asBinary => (asBinary ? res.arrayBuffer() : res.text()),
            }
          },
          // 添加样式
          addStyle(textContent) {
            const style = Object.assign(document.createElement('style'), {
              textContent
            })
            const ref = document.head.getElementsByTagName('style')[0] || null
            document.head.insertBefore(style, ref)
          },
        })
        this.remote = com
      },
    },
  }
  </script>
  <style>
  .async-component {
    width: 100%;
  }
  </style>
